/* eslint-disable no-undef */
import React from "react";
import FunctionalityButton from "./FunctionalityButton";
import { getToken } from "@/helpers/accessTokenHelper";
import { launchDocument } from "../utility/launchDocument";
import { ensureDocumentSaved } from "@/taskpane/utility/ensureDocumentSaved";

export default function Compare({ selected, setSelected, hovered, setHovered }) {
  const compare = async () => {
    const access_token = await getToken();
    setSelected("Compare");
    (JSON.parse(sessionStorage.getItem("document")).fileType !== "sent"
      ? ensureDocumentSaved()
      : Promise.resolve(true)
    ).then((saved) => {
      if (!saved) {
        setSelected("");
        return;
      }
      Office.context.document.getFilePropertiesAsync(async (context) => {
        const messageToShareDialog = JSON.stringify({
          url: context.value.url,
          access_token: access_token,
          id: JSON.parse(sessionStorage.getItem("document")).id,
          base: encodeURI(context.value.url),
          rootDocumentId: JSON.parse(sessionStorage.getItem("document")).rootDocumentId,
        });
        Office.context.ui.displayDialogAsync(
          `${process.env.BASE_URL}/Compare.html`,
          {
            width: 55,
            height: 75,
            displayInIframe: true,
          },
          (result) => {
            var dialog = result.value;
            dialog.addEventHandler(Office.EventType.DialogMessageReceived, (arg) => {
              var message = JSON.parse(arg.message);
              console.log(message);
              if (message.type === "IAmReady") {
                dialog.messageChild(messageToShareDialog);
              }
              if (message.type === "close") {
                dialog.close();
                setSelected("");
              }
              if (message.type === "open") {
                dialog.close();
                launchDocument(message.data);
              }
            });
          }
        );
      });
    });
  };
  return (
    <div>
      <FunctionalityButton
        buttonText="Compare"
        iconName="openEnrollment"
        color="#2b579a"
        onClickFunction={compare}
        selected={selected}
        hovered={hovered}
        setHovered={setHovered}
      />
    </div>
  );
}
